import React  from "react";
import AddCustomer from "./AddCustomer";

const Customer = () => {

  return (
    <div className="px-4 py-4">
      <AddCustomer />
    </div>
  );
};

export default Customer;
